import { render } from "./WayfindingLayout.vue?vue&type=template&id=28f1059e&scoped=true&ts=true"
import script from "./WayfindingLayout.vue?vue&type=script&lang=ts"
export * from "./WayfindingLayout.vue?vue&type=script&lang=ts"

import "./WayfindingLayout.vue?vue&type=style&index=0&id=28f1059e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f1059e"]])

export default __exports__